/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
// import { useToast } from "@/hooks/use-toast";
import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect } from "react";
import { useForm } from "react-hook-form";

import { z } from "zod";

type UseUserformType = {
  formData: any;
  onFormSubmit: (prop: any) => Promise<any>;
  open: boolean;
  onOpenChange: (prop: boolean) => void;
};

const formSchema = z.object({
  stop_key: z.any(),
  retailer_id: z
    .array(z.string())
    .nonempty({ message: "Retailer is required." }),
  // retailer_id: z.string().min(1, {
  //   message: "Retailer name is required.",
  // }),
});

export const useReactForm = ({
  formData,
  onFormSubmit,
  onOpenChange,
}: // open,
UseUserformType) => {
  // const { toast } = useToast();
  const schemaKeys = formSchema.keyof().options;

  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    mode: "onBlur",
    defaultValues: {
      stop_key: "",
      retailer_id: [],
    },
  });

  const control = form.control;

  useEffect(() => {
    if (formData && Object.keys(formData).length > 0) {
      schemaKeys.forEach((key) => {
        if (formData[key]) {
          if (key === "stop_key") {
            const value = formData[key];
            if (typeof value === "string") {
              const tempDataValue: any = value.split(",");
              form.setValue(key, tempDataValue, {
                shouldTouch: true,
                shouldDirty: true,
              });
            }
          } else {
            const value = formData[key];
            form.setValue(key, value, {
              shouldTouch: true,
              shouldDirty: true,
            });
          }
        }
      });
    }
  }, [formData]);

  async function onSubmit(values: z.infer<typeof formSchema>) {
    const { data } = await onFormSubmit(values);
    if (data) {
      // toast({
      //   title: "Success",
      //   variant: "success",
      //   description: data.status.msg,
      // });
      onOpenChange(false);
    }
  }

  return { form, onSubmit, control };
};
